var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-form',{staticClass:"gc-page-process"},[_c('popup-data-invalid',{attrs:{"errors":_vm.errors,"visible":_vm.hasError},on:{"close":function($event){return _vm.navigate()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }